import { SubAPI } from "./SubAPI";
export class Div10 extends SubAPI {
    replaceProducts(input) { return this.fetcher.post("/api/div-10/replace-product", input); }
    list(props) { return this.fetcher.get("/api/div-10", props); }
    summary(props) { return this.fetcher.get("/api/div-10/summary", props); }
    upsert(props) { return this.fetcher.post("/api/div-10", props); }
    overwriteFromQuoteMode(props) { return this.fetcher.post("/api/div-10/overwrite-from-quote-mode", props); }
    reOrder(props) { return this.fetcher.post("/api/div-10/re-order", props); }
}
